'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _route = require('./route.js');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Map = function () {
	function Map($container, settings) {
		(0, _classCallCheck3.default)(this, Map);

		this.routes = [];
		this.bounds = L.latLngBounds([]);
		this.$container = $container;
		this.settings = settings;

		var opts = {
			'attributionControl': false
		};
		this.mapService = L.map(this.$container.find('.prettyroutes-map-canvas:first').get(0), opts);
		this.mapService.addLayer(L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
		}));
		this.mapService.setView(this.settings.center, parseInt(this.settings.zoom), {
			animate: false
		});

		for (var i = 0; i < this.settings.routes.length; i++) {
			var routeSettings = this.settings.routes[i];
			var route = new _route2.default(this, routeSettings);
			this.addRoute(route);
		}

		this.refresh();
	}

	(0, _createClass3.default)(Map, [{
		key: 'addRoute',
		value: function addRoute(route) {
			var _this = this;

			if (!route.settings.valid) {
				return;
			}

			this.routes.push(route);
			for (var i = 0; i < route.waypoints.length; i++) {
				var waypoint = route.waypoints[i];
				this.bounds.extend([parseFloat(waypoint.latlng[0]), parseFloat(waypoint.latlng[1])]);
			}

			route.createLayer().then(function (routeLayer) {
				return _this.mapService.addLayer(routeLayer);
			});
		}
	}, {
		key: 'fitBounds',
		value: function fitBounds() {
			this.mapService.fitBounds(this.bounds);
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			if (this.settings.centerMode === 'auto') {
				this.fitBounds();
			}
		}
	}]);
	return Map;
}();

exports.default = Map;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map.js
// module id = 12
// module chunks = 0